import { graphql } from '../gql';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { mapPersonsToBrokers } from './shared/broker-utils';

export const GET_TEAM_PERSONS = graphql(`
  query getTeamPersons($teamId: String!) {
    persons(filters: { teamUuid: $teamId }) {
      edges {
        node {
          uuid
          firstName
          lastName
          agent
          status
        }
      }
    }
  }
`);

export function useGetTeamBrokers({
  teamId,
  enabled = true,
}: {
  teamId: string;
  enabled?: boolean;
}) {
  const { loading, error, data } = useQuery(GET_TEAM_PERSONS, {
    variables: {
      teamId,
    },
    skip: !enabled || !teamId,
  });

  const brokers = useMemo(() => {
    if (!data?.persons?.edges?.length) return [];

    return mapPersonsToBrokers(data.persons.edges, {
      teamName: '—',
    });
  }, [data]);

  return {
    error,
    loading,
    data,
    brokers,
  };
}
